import React, { useState, useEffect } from "react";
import axios from "axios";
import { useQueryString } from "../utils/utils";
// @ts-ignore - package.json import
import widgetsPackageData from "@labci/bell-fg-widgets/package.json";

import "./TestLinks.css";
import { ThemeType } from "@labci/bell-fg-widgets";

const TestLinks = () => {
  const query = useQueryString();

  const [token, setToken] = useState<string>("");
  const [uid, setUid] = useState<string>(
    query.get("uid") ? (query.get("uid") as string) : "",
  );
  const [pwd, setPwd] = useState<string>(
    query.get("pwd") ? (query.get("pwd") as string) : "",
  );
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [delayMode, setDelayMode] = useState<string>("1");
  const [theme, setTheme] = useState(ThemeType.Direct);
  const symbol = "CBA.ASX";
  const onClickLogin = () => {
    setIsFetching(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/gentoken`, {
        params: {
          uid: uid,
          pwd: pwd,
          perm: delayMode,
        },
      })
      .then((res) => {
        console.log("res", res);
        if (res.status !== 200) {
          setIsFetching(false);
          return;
        }
        console.log("res.data", res.data);
        setToken(res.data.data);
        setIsFetching(false);
      })
      .catch((err) => {
        setIsFetching(false);
      });
  };

  const list = (token: string) => {
    const basePath = process.env.REACT_APP_ROUTER_BASE || "";
    const tokenParam = `?token=${token}`;
    const symbolParam = `&symbol=${symbol}`;
    return (
      <>
        <h3>Market Overview</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/minichart${tokenParam}&region=AU&rics=${symbol}&showPeers=true&peerCount=10&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Mini Chart
          </a>
          <a
            href={`/${basePath}/mktindices${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Market Indices
          </a>
          <a
            href={`/${basePath}/heatmap${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Heatmap
          </a>
          <a
            href={`/${basePath}/topmovers${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Top Movers
          </a>
        </div>

        <h3>News</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/news${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            News
          </a>
          <a
            href={`/${basePath}/fullnews${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Full News
          </a>
        </div>

        <h3>Company Analysis</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/ownership${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Ownership
          </a>
          <a
            href={`/${basePath}/companyprofile${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Company Profile
          </a>
          <a
            href={`/${basePath}/pricehistory${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Price History
          </a>
          <a
            href={`/${basePath}/brokerrating${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Broker Rating
          </a>
          <a
            href={`/${basePath}/targetprice${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Target Price
          </a>
          <a
            href={`/${basePath}/companyscore${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Company Score
          </a>
          <a
            href={`/${basePath}/incomestatement${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Income Statement
          </a>
          <a
            href={`/${basePath}/balancesheet${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Balance Sheet
          </a>
          <a
            href={`/${basePath}/cashflow${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Cash Flow
          </a>
          <a
            href={`/${basePath}/keyratios${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Key Ratios
          </a>
          <a
            href={`/${basePath}/companyevent${tokenParam}${symbolParam}&theme=${theme}&eventType=all`}
            target="_blank"
            rel="noreferrer"
          >
            Company Event
          </a>
          <a
            href={`/${basePath}/companydirector${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Company Director
          </a>

          <a
            href={`/${basePath}/dividendhistory${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Dividend History
          </a>
          <a
            href={`/${basePath}/sentiment${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Sentiment
          </a>
          <a
            href={`/${basePath}/advancechart${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Advance Chart
          </a>
          <a
            href={`/${basePath}/indexchart${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Index Chart
          </a>
          <a
            href={`/${basePath}/fundsummary${tokenParam}${symbolParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Fund Summary
          </a>
        </div>

        <h3>Indices & Sectors</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/indices${tokenParam}&period=1M&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Indices
          </a>
          <a
            href={`/${basePath}/sectorindices${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Sector Indices
          </a>
          <a
            href={`/${basePath}/sectorheatmap${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Sector Heatmap
          </a>
        </div>

        <h3>Comparisons</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/stockpeercomparison${tokenParam}${symbolParam}&region=AU&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Stock Peer Comparison
          </a>
          <a
            href={`/${basePath}/indicespeercomparison${tokenParam}&region=all&index=XAO&tab=summary&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Indices Peer Comparison
          </a>
          <a
            href={`/${basePath}/sectorpeercomparison${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Sector Peer Comparison
          </a>
        </div>

        <h3>Recommendations</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/consensusrecommendation${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Consensus Recommendation
          </a>
        </div>

        <h3>Screener</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/screener${tokenParam}&theme=${theme}&region=AU`}
            target="_blank"
            rel="noreferrer"
          >
            Screener
          </a>
          <a
            href={`/${basePath}/fundscreener${tokenParam}&theme=${theme}&market=AU`}
            target="_blank"
            rel="noreferrer"
          >
            Fund Screener
          </a>
        </div>

        {/*<h3>Sector Analysis</h3>
                <div className="links-grid">
                    <a
                        href={`/${basePath}/sectoranalysis${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis
                    </a>
                    <a
                        href={`/${basePath}/sectoranalysis1${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis 1
                    </a>
                    <a
                        href={`/${basePath}/sectoranalysis2${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis 2
                    </a>
                    <a
                        href={`/${basePath}/sectoranalysisiframe${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis Iframe
                    </a>
                    <a
                        href={`/${basePath}/sectoranalysisiframe1${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis Iframe 1
                    </a>
                    <a
                        href={`/${basePath}/sectoranalysisiframe2${tokenParam}&theme=${theme}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sector Analysis Iframe 2
                    </a>
                </div>*/}

        <h3>Other Pages</h3>
        <div className="links-grid">
          <a
            href={`/${basePath}/dashboard${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Dashboard
          </a>
          <a
            href={`/${basePath}/iframe${tokenParam}&theme=${theme}`}
            target="_blank"
            rel="noreferrer"
          >
            Iframe Test Page
          </a>
          {/*<a
                        href={`/${basePath}/devpage${tokenParam}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Dev Page
                    </a>*/}
          {/*<a
                        href={`/${basePath}/version`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Version
                    </a>*/}
        </div>
      </>
    );
  };

  return (
    <div className={`test-links ${theme.toLowerCase()}`}>
      <div className="version-badge">{`Widget v${widgetsPackageData.version}`}</div>
      {token === "" && (
        <div className="login-container">
          <div className="login-card">
            <div className="login-header">
              <h1>Welcome Back</h1>
              <p>Sign in to access Widget</p>
            </div>
            <form
              className="login-form"
              onSubmit={(evt) => {
                evt.preventDefault();
                onClickLogin();
              }}
            >
              <div className="form-group">
                <label htmlFor="login-user">User ID</label>
                <input
                  id="login-user"
                  type="text"
                  value={uid}
                  onChange={(evt) => setUid(evt.target.value)}
                  placeholder="Enter your user ID"
                  disabled={isFetching}
                  autoComplete="username"
                />
              </div>
              <div className="form-group">
                <label htmlFor="login-pw">Password</label>
                <input
                  id="login-pw"
                  value={pwd}
                  type="password"
                  onChange={(evt) => setPwd(evt.target.value)}
                  placeholder="Enter your password"
                  disabled={isFetching}
                  autoComplete="current-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="delay-mode">Data Mode</label>
                <select
                  id="delay-mode"
                  value={delayMode}
                  onChange={(e) => setDelayMode(e.target.value)}
                  className="mode-select"
                  disabled={isFetching}
                >
                  <option value="1">Delay</option>
                  <option value="2">Real-time</option>
                </select>
              </div>
              <button
                type="submit"
                className="login-button"
                disabled={isFetching || !uid || !pwd}
              >
                {isFetching ? (
                  <>
                    <span className="spinner"></span>
                    Signing in...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>
          </div>
        </div>
      )}
      {token !== "" && (
        <div className={`content-container`}>
          <div className="theme-toggle-btn-container">
            <button
              className={`theme-toggle-btn ${theme === ThemeType.Direct ? "active" : ""}`}
              onClick={() => setTheme(ThemeType.Direct)}
            >
              Direct
            </button>
            <button
              className={`theme-toggle-btn ${theme === ThemeType.Potter ? "active" : ""}`}
              onClick={() => setTheme(ThemeType.Potter)}
            >
              Potter
            </button>
            <button
              className={`theme-toggle-btn ${theme === ThemeType.Desktop ? "active" : ""}`}
              onClick={() => setTheme(ThemeType.Desktop)}
            >
              Desktop
            </button>
          </div>
          {list(token)}
        </div>
      )}
    </div>
  );
};

export default TestLinks;
